import Vue from 'vue';
import VueRouter from 'vue-router';
import Start from '@/components/Start';
import AppSelect from '@/components/AppSelect';
import Login from '@/components/Login';
import Register from '@/components/My/Register';
import Main from '@/components/Main';
import Technician from '@/components/Technician';
import Agent from '@/components/Agent';
import M_PosBind from '@/components/Main/PosBind';
import M_PosWait from '@/components/Main/PosWait';
import M_ClientsList from '@/components/Main/ClientsList';
import M_Client from '@/components/Main/Client';
import M_ProductsList from '@/components/Main/ProductsList';
import M_Product from '@/components/Main/Product';
import M_ProductCateList from '@/components/Main/ProductCateList';
import M_TimeSelect from '@/components/Main/TimeSelect';
import M_WarehouseProductsList from '@/components/Main/WarehouseProductsList';
import M_WarehouseLog from '@/components/Main/WarehouseLog';
import M_MWarehouseProductsList from '@/components/Main/MWarehouseProductsList';
import M_MWarehouseSetting from '@/components/Main/MWarehouseSetting';
import M_ExtensionsSelect from '@/components/Main/ExtensionsSelect';
import M_SalesList from '@/components/Main/SalesList';
import M_Sale from '@/components/Main/Sale';
import M_UsersSelect from '@/components/Main/UsersSelect';
import M_Report from '@/components/Main/Report';
import M_Setting from '@/components/Main/Setting';
import M_OpenApi from '@/components/Main/OpenApi';
import M_OpenApiSetting from '@/components/Main/OpenApiSetting';
import M_OpenApiCateList from '@/components/Main/OpenApiCateList';
import M_OpenApiProductList from '@/components/Main/OpenApiProductList';
import M_Reset from '@/components/Main/Reset';
import M_My from '@/components/Main/My';
import M_Profile from '@/components/Main/Profile';
import M_Safety from '@/components/Main/Safety';
import M_About from '@/components/Main/About';
import M_News from '@/components/Main/News';
import M_StoreSelect from '@/components/Main/StoreSelect';
import T_ClientsList from '@/components/Technician/ClientsList';
import T_Client from '@/components/Technician/Client';
import T_Extension from '@/components/Technician/Extension';
import T_Cloud from '@/components/Technician/Cloud';
import T_NATService from '@/components/Technician/NATService';
import A_ClientsList from '@/components/Agent/ClientsList';
import A_Client from '@/components/Agent/Client';
import A_Report from '@/components/Agent/Report';
import A_TimeSelect from '@/components/Agent/TimeSelect';
import A_Extension from '@/components/Agent/Extension';
import DistList from '@/components/Agent/DistList';
import Dist from '@/components/Agent/Dist';
import TecList from '@/components/Agent/TecList';
import Tec from '@/components/Agent/Tec';
import A_Funds from '@/components/Agent/Funds';
import Qrcode from '@/components/Fun/Qrcode.vue';
import Dypassword from '@/components/Fun/Dypassword.vue';
import InstallCode from '@/components/Fun/InstallCode';
import Activation from '@/components/Fun/Activation';
import Checker from '@/components/Fun/Checker';
import Funds from '@/components/My/Funds';
import Profile from '@/components/My/Profile';
import Safety from '@/components/My/Safety';
import About from '@/components/My/About';
Vue.use(VueRouter)
const routes = [
  {
    path: '/Start',
    name: 'Start',
    component: Start
  },
  {
    path: '/AppSelect',
    name: 'AppSelect',
    component: AppSelect
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/Main',
    name: 'Main',
    component: Main
  },
  {
    path: '/M_PosBind',
    name: 'M_PosBind',
    component: M_PosBind
  },
  {
    path: '/M_PosWait',
    name: 'M_PosWait',
    component: M_PosWait
  },
  {
    path: '/Technician',
    name: 'Technician',
    component: Technician 
  },
  {
    path: '/Agent',
    name: 'Agent',
    component: Agent
  },
  {
    path: '/M_ClientsList',
    name: 'M_ClientsList',
    component: M_ClientsList
  },
  {
    path: '/M_Client',
    name: 'M_Client',
    component: M_Client
  },
  {
    path: '/M_ProductsList',
    name: 'M_ProductsList',
    component: M_ProductsList
  },
  {
    path: '/M_Product',
    name: 'M_Product',
    component: M_Product
  },
  {
    path: '/M_ProductCateList',
    name: 'M_ProductCateList',
    component: M_ProductCateList
  },
  {
    path: '/M_WarehouseProductsList',
    name: 'M_WarehouseProductsList',
    component: M_WarehouseProductsList
  },
  {
    path: '/M_WarehouseLog',
    name: 'M_WarehouseLog',
    component: M_WarehouseLog
  },
  {
    path: '/M_MWarehouseProductsList',
    name: 'M_MWarehouseProductsList',
    component: M_MWarehouseProductsList
  },
  {
    path: '/M_MWarehouseSetting',
    name: 'M_MWarehouseSetting',
    component: M_MWarehouseSetting
  },  
  {
    path: '/M_SalesList',
    name: 'M_SalesList',
    component: M_SalesList
  },
  {
    path: '/M_Sale',
    name: 'M_Sale',
    component: M_Sale
  },
  {
    path: '/M_ExtensionsSelect',
    name: 'M_ExtensionsSelect',
    component: M_ExtensionsSelect
  },
  {
    path: '/M_UsersSelect',
    name: 'M_UsersSelect',
    component: M_UsersSelect
  },
  {
    path: '/M_Report',
    name: 'M_Report',
    component: M_Report
  },
  {
    path: '/M_Setting',
    name: 'M_Setting',
    component: M_Setting
  },
  {
    path: '/M_OpenApi',
    name: 'M_OpenApi',
    component: M_OpenApi
  },
  {
    path: '/M_OpenApiSetting',
    name: 'M_OpenApiSetting',
    component: M_OpenApiSetting
  },
  {
    path: '/M_OpenApiCateList',
    name: 'M_OpenApiCateList',
    component: M_OpenApiCateList
  },
  {
    path: '/M_OpenApiProductList',
    name: 'M_OpenApiProductList',
    component: M_OpenApiProductList
  },
  {
    path: '/M_Reset',
    name: 'M_Reset',
    component: M_Reset
  },
  {
    path: '/M_TimeSelect',
    name: 'M_TimeSelect',
    component: M_TimeSelect
  },
  {
    path: '/M_My',
    name: 'M_My',
    component: M_My
  },
  {
    path: '/M_Profile',
    name: 'M_Profile',
    component: M_Profile
  },
  {
    path: '/M_Safety',
    name: 'M_Safety',
    component: M_Safety
  },
  {
    path: '/M_About',
    name: 'M_About',
    component: M_About
  },
  {
    path: '/M_News',
    name: 'M_News',
    component: M_News
  },
  {
    path: '/M_StoreSelect',
    name: 'M_StoreSelect',
    component: M_StoreSelect
  },
  {
    path: '/T_ClientsList',
    name: 'T_ClientsList',
    component: T_ClientsList
  },
  {
    path: '/T_Client',
    name: 'T_Client',
    component: T_Client
  },
  {
    path: '/T_Extension',
    name: 'T_Extension',
    component: T_Extension
  },
  {
    path: '/T_Cloud',
    name: 'T_Cloud',
    component: T_Cloud
  },
  {
    path: '/T_NATService',
    name: 'T_NATService',
    component: T_NATService
  },
  {
    path: '/A_ClientsList',
    name: 'A_ClientsList',
    component: A_ClientsList
  },
  {
    path: '/A_Client',
    name: 'A_Client',
    component: A_Client
  },
  {
    path: '/A_Report',
    name: 'A_Report',
    component: A_Report
  },
  {
    path: '/A_TimeSelect',
    name: 'A_TimeSelect',
    component: A_TimeSelect
  },
  {
    path: '/A_Extension',
    name: 'A_Extension',
    component: A_Extension
  },
  {
    path: '/DistList',
    name: 'DistList',
    component: DistList
  },
  {
    path: '/Dist',
    name: 'Dist',
    component: Dist
  },
  {
    path: '/TecList',
    name: 'TecList',
    component: TecList
  },
  {
    path: '/Tec',
    name: 'Tec',
    component: Tec
  },
  {
    path: '/A_Funds',
    name: 'A_Funds',
    component: A_Funds
  },
  {
    path: '/Qrcode',
    name: 'Qrcode',
    component: Qrcode
  },
  {
    path: '/Dypassword',
    name: 'Dypassword',
    component: Dypassword
  },
  {
    path: '/InstallCode',
    name: 'InstallCode',
    component: InstallCode
  },
  {
    path: '/Activation',
    name: 'Activation',
    component: Activation
  },
  {
    path: '/Checker',
    name: 'Checker',
    component: Checker
  },
  {
    path: '/Funds',
    name: 'Funds',
    component: Funds
  },
  {
    path: '/Profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/Safety',
    name: 'Safety',
    component: Safety
  },
  {
    path: '/About',
    name: 'About',
    component: About
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js